import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage: React.FC = () => {
  return (
    <div className="text-center py-10">
      <h1 className="text-4xl font-bold text-error mb-4">404 - Not Found</h1>
      <p className="text-base-content/80 mb-6">
        Sorry, the page you are looking for does not exist.
      </p>
      <Link to="/" className="link link-primary">
        Go back to the Report List
      </Link>
    </div>
  );
};

export default NotFoundPage;
